import type { RouteStop } from '../../../data/routeStops';

/**
 * 駅選択ドロップダウン。
 * - stops は stop_sequence 昇順で渡される前提。
 * - value が stops に存在しない (= マスタ未取得 / 別バージョン) 場合も選択肢として残し、
 *   既存値が消えないようにする。
 */
export function StopSelect({
  ariaLabel,
  testId,
  value,
  stops,
  disabled,
  onChange,
}: {
  ariaLabel: string;
  /**
   * data-testid 属性。E2E 等から `[data-testid="..."]` で一意に拾うため。
   * aria-label が「乗換駅」「遅延判定開始駅」のように似通っており AI/E2E が
   * 取り違えやすいので、明示的な testid を渡せるようにしている。
   */
  testId?: string;
  value: string;
  stops: RouteStop[];
  disabled?: boolean;
  onChange: (stopId: string) => void;
}): React.JSX.Element {
  const isUnknownStop = value !== '' && !stops.some((s) => s.stop_id === value);
  return (
    <select
      aria-label={ariaLabel}
      data-testid={testId}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">(指定なし)</option>
      {stops.map((s) => (
        <option key={s.stop_id} value={s.stop_id}>
          {s.stop_name || s.stop_id}
        </option>
      ))}
      {isUnknownStop ? <option value={value}>{value} (マスタ未取得)</option> : null}
    </select>
  );
}
